<template>
  <div id="invoiceHistory" class="invoice-history-page">
    <div class="invoiceList">
      <van-list
        v-if="totalRows > 0"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多啦"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div
          class="item"
          v-for="(item, index) in historyInfo"
          :key="index"
          :id="item.invoiceId"
          @click="detailInfo(item.invoiceId)"
        >
          <!-- item上半部分 -->
          <div class="time">
            <img
              src="@/assets/img/issueInvoice/history_time.png"
              class="icon"
              alt=""
            />
            <span class="histime">
              {{ momentTime(item.createTime) }}
            </span>
          </div>
          <!-- item下半部分 -->
          <div class="bottomInfo">
            <div class="invoiceType">电子发票</div>
            <div class="invoiceAmount">
              <span class="moneySymbol">￥</span>
              {{ item.amount }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-if="totalRows == 0" class="nohistory">
      <img src="@/assets/img/issueInvoice/history_null.png" />
      <p class="tiptext">暂无开票记录</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "invoiceHistory",

  data() {
    return {
      loading: false,
      finished: false,
      totalRows: 60,
      error: false,
      list: [],
      sortList: [],
      historyInfo: [],
      pageNo: 1,
      pageSize: 20,
    };
  },
  computed: {
    ...mapState("invoiceApply", "cityCode"),
  },
  methods: {
    // 获取开具历史
    getHistortList() {
      this.$api.invoice
        .invoiceHistoryList({
          pageSize: this.pageSize,
          offset: this.pageSize * (this.pageNo - 1),
        })
        .then((res) => {
          if (res.errcode == 0) {
            this.totalRows = res.data.totalRows;
            let dataList = res.data.content;
            this.historyInfo = this.historyInfo.concat(dataList); //关键代码
            this.loading = false;
            this.pageNo += 1;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    // 开票历史时间
    momentTime(timestamp) {
      let d = new Date(timestamp); //根据时间戳生成的时间对象
      let Minutes = d.getMinutes();
      if (Minutes < 10) {
        Minutes = "0" + Minutes;
      }
      var date =
        d.getFullYear() +
        "年" +
        (d.getMonth() + 1) +
        "月" +
        d.getDate() +
        "日" +
        "  " +
        d.getHours() +
        ":" +
        Minutes;
      return date;
    },
    // loading
    onLoad() {
      if (this.historyInfo.length >= this.totalRows) {
        this.finished = true;
        return;
      }
      this.getHistortList();
    },
    // 跳转到开票详情
    detailInfo(id) {
      this.$router.push({
        path: "/invoice/detail",
        query: { id, city: this.cityCode },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-history-page {
  background: #f7f8fa;
  height: 100vh; // 没有开票历史
  .nohistory {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 218px;
      height: 110px;
    }
  }
  .tiptext {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
  // 有开票历史
  .invoiceList {
    padding-top: 4px;
    background: #f7f8fa;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 343px;
      height: 96px;
      background: #ffffff;
      border-radius: 6px;
      margin: 0 auto;
      margin-bottom: 12px;
      margin-top: 16px;
      padding: 24px 16px;
      .time {
        font-size: 14px;
        line-height: 12px;
        color: #212831;
        .icon {
          display: block;
          float: left;
          width: 13px;
          height: 13px;
          margin-right: 6px;
        }
        .histime {
          display: block;
          height: 12px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #212831;
          line-height: 12px;
        }
      }
      .bottomInfo {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .invoiceType {
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #212831;
          line-height: 25px;
        }
        .invoiceAmount {
          display: table-cell; //元素作为表格单元显示
          vertical-align: bottom; //设置元素垂直对齐方式
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #e02727;
          line-height: 25px;
          .moneySymbol {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
